export const SpecificRule = [
    { label: 'Increase Rate', value: 'increase' },
    { label: 'Decrease Rate', value: 'decrease' },
];

export type SpecificRuleType = typeof SpecificRule[number]['value'];